// extracted by mini-css-extract-plugin
module.exports =  {"fullscreen":"b429494557--fullscreen--mfCte","no-print":"b429494557--no-print--WH57H"};